<template>
  <div class="big">
    <div class="page_title">退款设置</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="text">
          以下情况勾选后退款不需要发送验证码
        </div>
        <el-checkbox
          v-model="item.status"
          v-for="(item,index) in config_list"
          :key="index"
          :true-label="1"
          :false-label="0"
          style="margin-bottom:16px"
        >{{item.value}}</el-checkbox>
        <div style="margin-top:100px">
          <el-button
            type="primary"
            style="width:90px"
            size="medium"
            @click="setRefundConfig"
            :disabled="module_id_array[0]? !module_id_array.includes('1412'): false"
          >保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      config_list: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    getRefundConfigList() {
      this.axios.post('platform/order/getRefundConfigList').then((res) => {
        this.config_list = res.data.list;
      });
    },
    setRefundConfig() {
      let list = this.config_list;
      this.axios
        .post('platform/order/setRefundConfig', { list })
        .then((res) => {
          this.config_list = res.data.list;
          this.$message.success('保存成功');
          this.getRefundConfigList();
        });
    }
  },
  created() {
    this.getRefundConfigList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px 0 20px 100px;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.text {
  font-size: 16px;
  margin-bottom: 20px;
}
</style>